import { useState } from "react";
import { DropdownItem } from "./dropdown/DropdownItem";
import { Dropdown } from "./dropdown/Dropdown";
import { Link } from "react-router-dom";
import GlobalStore from "@stores/GlobalStore";
import {
  User,
  ChevronDown,
  UserRound,
  Settings,
  Info,
  LogOut,
} from "lucide-react";

const LOGOUT_TIMEOUT = 500;

export default function UserDropdown() {
  const [isOpen, setIsOpen] = useState(false);

  function toggleDropdown() {
    setIsOpen(!isOpen);
  }

  function closeDropdown() {
    setIsOpen(false);
  }

  const Logout = () => {
    localStorage.removeItem("ttpUserId");
    localStorage.removeItem("reports");
    localStorage.removeItem("topicsHierarchy_v2_");
    localStorage.removeItem("dashboardStatev3");

    GlobalStore.setGlobalSettings({
      ttpUserId: null,
      callback: () => {
        setTimeout(() => {
          window.location.href = "/login";
        }, LOGOUT_TIMEOUT);
      },
    });
  };
  return (
    <div className="relative">
      <button
        onClick={toggleDropdown}
        className="flex items-center text-gray-700 dropdown-toggle dark:text-white"
      >
        <span className="mr-3 overflow-hidden rounded-full">
          <User />
        </span>

        <span className="block mr-1 font-medium text-theme-sm">User</span>
        <ChevronDown
          className={`stroke-gray-500 dark:stroke-gray-400 transition-transform duration-200 ${
            isOpen ? "rotate-180" : ""
          }`}
          size={20}
        />
      </button>

      <Dropdown
        isOpen={isOpen}
        onClose={closeDropdown}
        className="absolute right-0 mt-[17px] flex w-[260px] flex-col rounded-2xl border border-gray-200 bg-white p-3 shadow-theme-lg dark:border-gray-800 dark:bg-gray-dark"
      >
        <div>
          <span className="block font-medium text-gray-700 text-theme-sm dark:text-white  ">
            User name
          </span>
          <span className="mt-0.5 block text-theme-xs text-gray-500 dark:text-white ">
            username@swittle.com
          </span>
        </div>

        <ul className="flex flex-col gap-1 pt-4 pb-3 border-b border-gray-200 dark:border-gray-800">
          <li>
            <DropdownItem
              onItemClick={closeDropdown}
              tag="a"
              className="flex items-center gap-3 px-3 py-2 font-medium text-gray-700 rounded-lg group text-theme-sm hover:bg-gray-100 hover:text-gray-700 dark:text-white  dark:hover:bg-white/5 dark:hover:text-gray-300"
            >
              <UserRound className=" group-hover:fill-gray-300 dark:group-hover:fill-gray-600" />
              Edit profile
            </DropdownItem>
          </li>
          <li>
            <DropdownItem
              onItemClick={closeDropdown}
              tag="a"
              className="flex items-center gap-3 px-3 py-2 font-medium text-gray-700 rounded-lg group text-theme-sm hover:bg-gray-100 hover:text-gray-700 dark:text-white dark:hover:bg-white/5 dark:hover:text-gray-300"
            >
              <Settings className=" group-hover:fill-gray-300 dark:group-hover:fill-gray-600" />
              Account settings
            </DropdownItem>
          </li>
          <li>
            <DropdownItem
              onItemClick={closeDropdown}
              tag="a"
              className="flex items-center gap-3 px-3 py-2 font-medium text-gray-700 rounded-lg group text-theme-sm hover:bg-gray-100 hover:text-gray-700 dark:text-white dark:hover:bg-white/5 dark:hover:text-gray-300"
            >
              <Info className=" group-hover:fill-gray-300 dark:group-hover:fill-gray-600" />
              Support
            </DropdownItem>
          </li>
        </ul>
        <Link
          onClick={() => Logout()}
          to="/signin"
          className="flex items-center gap-3 px-3 py-2 mt-3 font-medium text-gray-700 rounded-lg group text-theme-sm hover:bg-gray-100 hover:text-gray-700 dark:text-white dark:hover:bg-white/5 dark:hover:text-gray-300"
        >
          <LogOut className="rotate-180" />
          Sign out
        </Link>
      </Dropdown>
    </div>
  );
}
